<template>
  <div>
    <HeaderContent title="Extracharge"/>
    <ActionContent ctaText="Add Extracharge" @action="modal = !modal" :filterDate="false"/>
    <ExtraChargeStatistics title="Extra Charge Statistics" :data="statistics" />
    <ExtraChargeForm :modal="modal" @update:modal="modal = $event"/>
    <ExtraChargeConfirm title="Confirmation" :modalConfirm="modalConfirm" @update:modalConfirm="modalConfirm = $event">
      <template #text>Are you sure to delete this data ?</template>
    </ExtraChargeConfirm>
    <ExtraChargeDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
  </div>
</template>

<script>
import { ref } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import ExtraChargeForm from "./ExtraChargeForm.vue";
import ExtraChargeConfirm from "@/components/ModalDialog.vue";
import ExtraChargeStatistics from "@/components/StatisticData.vue";
import ExtraChargeDataTable from "@/components/DataTable.vue";
import iconCategory from '../../../public/icons/category-alt.svg';
import iconItem from '../../../public/icons/boxes.svg';

export default {
  components: {
    HeaderContent,
    ActionContent,
    ExtraChargeForm,
    ExtraChargeConfirm,
    ExtraChargeStatistics,
    ExtraChargeDataTable,
  },
  setup(){
    const data = ref([
      {
        category: 'resto',
        name: 'Ayam Rujak',
        price: 40000,
        // quantity: 1,
      },
      {
        category: 'resto',
        name: 'Lunch Buffet 30 Pax',
        price: 40000,
        // quantity: 1,
      },
      {
        category: 'travel',
        name: 'Airport Shuttle 9 Person',
        price: 40000,
        // quantity: 1,
      },
      {
        category: 'travel',
        name: 'City Tour in Medan',
        price: 40000,
        // quantity: 1,
      },
      {
        category: 'hotel',
        name: 'Extra Bed',
        price: 40000,
        // quantity: 1,
      },
    ])
    const customActions = ref([
      {
          label: 'Edit',
          variant: 'success',
          icon: 'fas fa-edit',
          action: (item) => {
          console.log('Edit action clicked for:', item);
          // Implement your edit logic here
          }
      },
      {
          label: 'Delete',
          variant: 'danger',
          icon: 'fas fa-trash',
          action: (item) => {
          console.log('Delete action clicked for:', item);
          // Implement your delete logic here
          }
      },
      
    ]);
    const headers = ref([
      {key: 'category', label: 'Category', sortable: true},
      {key: 'name', label: 'Name', sortable: true},
      {key: 'price', label: 'Price', sortable: true},
      {key: 'action', label: 'Actions'}
    ])
    const modal = ref(false)
    const modalConfirm = ref(false)

    const statistics = ref([
      {
        label: 'Total',
        key: 'Category',
        value: 3,
        color: 'primary',
        icon: iconCategory
      },
      {
        label: 'Total',
        key: 'Item',
        value: 5,
        color: 'primary',
        icon: iconItem
      },
    ])

    return{
      data,
      headers,
      modal,
      modalConfirm,
      customActions,
      statistics
    }
  }

}
</script>

<style>

</style>